import styles from "./index.module.scss"
import Select from "../../../../atoms/Select"
import intl from "react-intl-universal"

export const TopRelease = ({ setOrder, activeTab, setActiveTab }) => {
  return (
    <div className={styles.wrapperTop}>
      <div className={styles.contentTab}>
        <span
          className={`${styles.tab} ${activeTab && styles.tabActive}`}
          onClick={() => {
            setActiveTab(true)
          }}
        >
          {intl.get("ciq.releases")}
        </span>
        <span
          className={`${styles.tab} ${!activeTab && styles.tabActive}`}
          onClick={() => {
            setActiveTab(false)
          }}
        >
          {intl.get("ciq.releases-analysis")}
        </span>
      </div>
      <div className={styles.order}>
        <span> {intl.get("ciq.order")}:</span>
        <Select
          className={styles.select}
          label=""
          searchable={false}
          defaultValue={{ label: "Alfabética A-Z", value: "asc" }}
          options={[
            {
              label: "Alfabética A-Z",
              value: "asc",
            },
            {
              label: "Alfabética Z-A",
              value: "desc",
            },
            {
              label: "Ordem do Equipamento",
              value: "equipment",
            },
          ]}
          onSelect={(e) => setOrder(e.value)}
        />
      </div>
    </div>
  )
}
